import { render, staticRenderFns } from "./DrillAiOneSimilarMath.vue?vue&type=template&id=bbf30428&scoped=true&lang=pug&"
import script from "./DrillAiOneSimilarMath.vue?vue&type=script&lang=ts&"
export * from "./DrillAiOneSimilarMath.vue?vue&type=script&lang=ts&"
import style0 from "./DrillAiOneSimilarMath.vue?vue&type=style&index=0&id=bbf30428&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf30428",
  null
  
)

export default component.exports